import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";
import { ICataloguedItems } from "../types/wizard-types";

export const getStoreItems = (
  token,
  pos_entity_id?: string
): AxiosReturn<ICataloguedItems[]> => {
  return axios.get(Requests.storeItems, {
    headers: {
      token,
    },
    params: {
      pos_entity_id,
      ...(pos_entity_id ? { include_pos_entity_id: 1 } : {}),
    },
  });
};
